/**
 * Get cookie value by name
 */
// export function getCookie(name: string): string | null {
//   const value = `; ${document.cookie}`;
//   const parts = value.split(`; ${name}=`);
//   if (parts.length === 2) {
//     return parts.pop()?.split(';').shift() || null;
//   }
//   return null;
// }

import VueCookies from 'vue-cookies';

export function getCookie(key: string): any {
  // @ts-expect-error this is a vue-cookies library
  return VueCookies.get(key) || null;
}
